import React from 'react'
import ConfirmationPopup from '../../../../../components/popup/confirmationpopup/ConfirmationPopup'
import { VEC_ICON_NAME } from '../../../../../components/icons/constants'
import { BUTTON_TYPE } from '../../../../../components/button/constants'

const PrepayAccessConfirmationModal = ({ isOpen = false, onSubmitCb = () => { }, onCancelCb = () => { }, onCloseCb = () => { } }) => {
    return (
        <ConfirmationPopup
            title=''
            bodyText={`Do you want your member users to have access to these prepay funds? Choose an
option: If you click 'Yes', member users can use these funds; or 'No', member users
cannot use these funds.`}
            iconName={VEC_ICON_NAME.WARNING_ICON}
            isOpen={isOpen}
            confirmationButtonProps={{
                onConfirmationCb: onSubmitCb,
                confirmationButtonText: "Yes",
                confirmationButtonStyles: {},
                confirmationButtonType: BUTTON_TYPE.PRIMARY,
            }}
            isClose={false}
            cancelButtonProps={{
                onCancelCb: onCancelCb,
                onCloseCb: onCloseCb,
                cancelButtonText: "No",
                cancelButtonStyles: {},
                cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
            }}
            customStyle={{ minWidth: "800px" }}
        />
    )
}

export default PrepayAccessConfirmationModal